<template>
    <div v-if="display">
        <div class="container header-margin ">

            <div class="text-center p-2 wrap-text">
                <h2 class="main_title">{{ $t('aube_quest.registration.title') }}</h2>
            </div>

            <div class="info-box">
                <small class="text-muted">{{ $t('aube_quest.registration.title_quest_info') }}</small>
                <div>Quest ID: {{ quest_id }}</div>
                <div>Connector ID: {{ connectorMemberId }}</div>
                <div>{{ $t('aube_quest.connector_start_date') }}: {{ joinedDate }}</div>
                <div v-if="errors.quest_id" class="error-message">{{ errors.quest_id }}</div>
            </div>

            <div class="tab-content p-2" >
                <div class="row no-gutters text-center navigation">
                    <div id="box1" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-box">{{ $t('auth.navigationForceclub.title1') }}</p></div>
                    <div id="box2" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-box">{{ $t('auth.navigationForceclub.title2') }}</p></div>
                    <div id="box3" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-box">{{ $t('auth.navigationForceclub.title3') }}</p></div>
                    <div id="box4" class="col-md-3 col-sm-3 col-xs-5 box-area active-color-box"><p class="text-box">{{ $t('auth.navigationForceclub.title4') }}</p></div>
                </div>

                <div class="registration-complete-container">
                    <div class="text-center p-2">
                        <h3 class="text-color sub_title">{{ $t('aube_quest.registration.complete.title') }}</h3>
                    </div>

                    <div class="icon-success d-flex justify-content-center my-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 48 48" fill="none"
                            stroke="green" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="24" cy="24" r="22" stroke="green" fill="none" />
                            <path d="M14 24l6 6 14-14" />
                        </svg>
                    </div>

                    <div class="completion-content-box">
                        <div class="success-message pre">
                            {{ $t('aube_quest.registration.complete.text') }}
                        </div>

                        <div class="info-section acc-info">
                            <p class="text-muted">{{ $t('aube_quest.connected.title_info2') }}</p>
                            <p class="text-muted">{{ $t('aube_quest.connected.title_mail') }}</p>
                            <label for="email">{{ email }}</label>
                        </div>

                        <div class="info-section quest-info">
                            <p class="text-muted">{{ $t('aube_quest.title_quest_id') }}</p>
                            <label for="quest_id">{{ quest_id }}</label>
                        </div>
                    </div>

                    <div class="text-center">
                        <button type="button" @click="handleOnSubmit" class="btn btn-primary">
                            {{ $t('aube_quest.btn_return_top') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import UserService from '../../../../services/UserService';
    import RecaptchaMixin from '../../../../utils/RecaptchaMixin';
    import questService from "../../../../services/QuestService";

    export default {
        name: 'registration-module',
        mixins: [RecaptchaMixin],
        data() {
            return {
                display: false,
                quest_id: '',
                connectorMemberId: '',
                joinedDate: '',
                email: '',
                errors: {
                    quest_id: ''
                }
            }
        },
        created() {
            this.fetchUserData();
            this.getEmail();
        },
        mounted() {
            this.maxHeight();
        },
        methods: {
            async handleOnSubmit() {
                this.$router.push('/');
            },
            async getEmail() {
                try {
                    const { data } = await UserService.getUserFrontendData();
                    this.email = data.email;
                    this.quest_id = data.quest.quest_id || '';
                    this.connectorMemberId = data.connector.connector_id;
                    this.joinedDate = data.connector.joined_date;
                    this.isLoaded = true;
                } catch (e) {
                    console.log(e);
                } finally {
                }
            },

            async fetchUserData() {
                try {
                    if (sessionStorage.formData) {
                        this.formData = JSON.parse(sessionStorage.formData);
                        const result = await UserService.getUserConfirmDataByMail(this.formData);
                        if (result.data.member_type_id == 2100 ||
                            result.data.member_type_id == 2200
                        ) {
                            this.$router.push('/');
                        } else {
                            this.display = true
                            this.email = result.data.email;
                            if (sessionStorage.formData) {
                                this.formData = JSON.parse(sessionStorage.formData);
                            }
                            this.maxHeight();
                        }
                    } else {
                        this.$router.push('/');
                    }
                } catch (e) {
                    this.$router.push('/');
                }
            },
            async maxHeight() {
                setTimeout(() => {
                    let box1 = document.getElementById('box1').clientHeight
                    let box2 = document.getElementById('box2').clientHeight
                    let box3 = document.getElementById('box3').clientHeight
                    let box4 = document.getElementById('box4').clientHeight
                    let maxHeight = Math.max(box1,box2,box3,box4);
                    document.getElementById('box1').style.height = maxHeight+'px'
                    document.getElementById('box2').style.height = maxHeight+'px'
                    document.getElementById('box3').style.height = maxHeight+'px'
                    document.getElementById('box4').style.height = maxHeight+'px'
                 }, 1000);
            },
        }
    }
</script>
<style scoped>
    .main_title{
        margin-bottom:15px;
    }
    .header-margin{
        top:250px;
    }
    .pre {
        white-space: pre-line;
    }
    .active-color-box{
        background: #451493;
        border-color:#451493;
    }
    .non-active-color-box{
        background: #bdbebd;
    }
    /* ボタンのスタイル指定 */
    .btn-primary{
        width: 200px;
    }
    .text{
        font-size: 25px;
    }
    .wrap-text{
        padding-bottom: 20px;
    }
    .box-area {
        padding: 0.5em 0em;
        width:50%;
        color: #FFF;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #box2,#box3,#box4{
        outline: 1px solid #FFF;
    }
    .box-area p {
        margin-top: 2px;
        margin-bottom: 2px;
        padding-top: 1px;
    }
    .navigation{
        padding-top:15px;
        padding-bottom:40px;
    }
    .text-color{
        color: #451493;
    }
    .info-box {
        background-color: #f7f7f7;
        border-radius: 6px;
        padding: 12px 16px;
        margin-bottom: 20px;
        margin-top: 20px;
        border: 1px solid #ebeaea;
        max-width: 600px;
        margin-left: auto;
        margin-right: auto;
    }
    .info-box small {
        display: block;
        color: #6c757d;
        margin-bottom: 4px;
        font-size: 0.85rem;
    }
    .info-box div {
        font-weight: 500;
        font-size: 0.95rem;
    }

    /*スマホ用css*/
    @media screen and (max-width: 479px) {
        .box-area[data-v-40212d93] {
            height: 90px;
        }
        .form-group{
            padding-left: 0px;
        }
        .header-margin{
            padding-left: 0px;
            padding-right: 0px;
        }
        .main_title{
            font-size: 1.575rem;
            margin-bottom: 0px;
        }
        .sub_title{
            font-size: 1.3rem;
            margin-bottom: 0px;
        }
        .navigation{
            padding-top: 0px;
            padding-bottom:15px;
        }
    }

    /* Main container styles */
    .registration-complete-container {
        max-width: 800px;
        margin: 0 auto;
        padding: 20px;
    }

    .icon-success svg {
        width: 50px;
        height: 50px;
    }

    /* Success message */
    .success-message {
        font-weight: 600;
        color: #333;
        margin-bottom: 25px;
    }

    /* Info sections */
    .info-section {
        text-align: left;
        margin-bottom: 20px;
    }

    .info-section small {
        display: block;
        color: #6c757d;
        font-size: 0.85rem;
        margin-bottom: 5px;
    }

    .info-section label {
        font-weight: 600;
        color: #333;
        display: block;
    }

    /* Button styling */
    .btn-return-top {
        background-color: #663399;
        border-color: #663399;
        color: white;
        padding: 12px 30px;
        font-size: 1rem;
        font-weight: 500;
        border-radius: 4px;
        margin-top: 20px;
    }

    .btn-return-top:hover {
        background-color: #552288;
        border-color: #552288;
    }

    /* Text color for main title */
    .text-color {
        color: #663399;
    }

    /* Responsive design */
    @media screen and (max-width: 768px) {

        .sub_title {
            font-size: 1.5rem;
        }

        .icon-success svg {
            width: 48px;
            height: 48px;
        }
    }
</style>
